function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import styled from 'astroturf'
import classNames from 'classnames';
import React from 'react';
import BaseDropdown from 'react-bootstrap/Dropdown';
import Button from './Button'; // TODO: Use a more lightweight wrapper than styled, given that this applies
//  no styling overrides.

const DropdownToggle = /*#__PURE__*/styled(BaseDropdown.Toggle, null, {
  displayName: "DropdownToggle",
  styles: require("./Dropdown-DropdownToggle.module.scss"),
  attrs: null,
  vars: []
});
DropdownToggle.defaultProps = {
  as: Button
};
const DropdownDivider = /*#__PURE__*/styled(BaseDropdown.Divider, null, {
  displayName: "DropdownDivider",
  styles: require("./Dropdown-DropdownDivider.module.scss"),
  attrs: null,
  vars: []
});
const itemStyles = require('./Dropdown-itemStyles.module.scss');

function DropdownItem({
  children,
  icon,
  theme,
  className,
  ...props
}) {
  return React.createElement(BaseDropdown.Item, _extends({}, props, {
    className: classNames(className, itemStyles.item, theme && itemStyles[theme], icon && itemStyles.icon)
  }), icon ? React.createElement(React.Fragment, null, React.createElement("span", null, icon), React.createElement("div", null, children)) : children);
} // Wrap a fake styled component around the base Dropdown class to strip off its
// statics, to avoid TypeScript failing to merge the overridden statics.
// TODO: Use a more lightweight wrapper than styled, given that this applies
//  no styling overrides.


export default Object.assign(/*#__PURE__*/styled(BaseDropdown, null, {
  displayName: "Dropdown",
  styles: require("./Dropdown.module.scss"),
  attrs: null,
  vars: []
}), {
  Toggle: DropdownToggle,
  Menu: BaseDropdown.Menu,
  Item: DropdownItem,
  Header: BaseDropdown.Header,
  Divider: DropdownDivider
});